/*
 * RESADE rs-topf.js: Topf-Warenkorb im Kopf (05 4.2, 8.4; 01 E-50, E-51). Klassisches Skript mit defer,
 * geladen von sections/rs-warenkorb-drawer.liquid, also auf jeder Seite.
 *
 * Hält die Zahl im Topf (ab 100 „99+“) und den versteckten Namen („Warenkorb, 2 Artikel“) aktuell und steuert
 * Deckel, Dampf und Zahl über Klassen am .rs-topf: nimmt-auf, klappert (Deckel mit etwas Dampf), dampft,
 * zaehlt. Die Bewegungen selbst sind CSS in assets/rs-base.css (05 Abschnitt 9).
 * Bewegt werden nur Deckel (rs-topf__deckel), Dampf (Gruppe rs-topf__dampf, austauschbar) und Zahl,
 * nie das ganze Symbol.
 *
 * Hört auf (05 8.6):
 *   rs:warenkorb:geaendert   Zahl und Name setzen; ist die Zahl gestiegen, springt sie
 *   rs:warenkorb:hinzugefuegt  ohne detail.landung: Deckel klappert, etwas Dampf; mit Landung nichts
 *   rs:flug:anflug           Deckel geht weit auf
 *   rs:flug:gelandet         Deckel schließt mit Klappern
 *   rs:flug:abgebrochen      Deckel schließt ohne Klappern
 *   rs:versand:frei          einmal kräftiger Dampf, Deckel hebt sich deutlich
 *   pageshow (persisted)     nur ohne rs-cart.js: Stand von /cart.js holen und die Zahl setzen (Ladezeit-Runde
 *                            03.10.2026, A1; auf der Startseite lädt im Popup-Modus kein rs-cart.js)
 * Seit E-158 (Denny: „falls was im Warenkorb ist kann der manchmal aufköcheln, nur ab und zu“): Liegt etwas im
 * Warenkorb, köchelt der Kopf-Topf von selbst (Klasse koechelt, der Deckel springt kurz hoch). Seit E-161 (Denny:
 * „alle fünf Sekunden oder so, berechne mal, was wirklich Sinn macht“): erstes Mal nach 8 s, dann alle 12 bis 18 s,
 * höchstens 4 Mal je Seitenaufruf (4 × 900 ms, unter 5 s Bewegung), nach dem ersten Artikel 15 s später. Ein
 * ausgelassener Schlag zählt nicht und kommt nach 4 s erneut: außer Sicht (Shrines Kopf blendet nur beim Hochscrollen
 * ein), bis 3 s nach Scrollen, Tippen oder einer Taste, bei Hover oder Fokus, offenem Warenkorb, Menü oder Dialog,
 * verborgenem Tab. Ladezeit-Runde 03.10.2026 (B7): Nach fünf ausgelassenen Schlägen in Folge ruht die Wiederholung,
 * bis gescrollt, getippt oder eine Taste gedrückt wird oder der Tab wieder sichtbar ist; dann gelten wieder fünf
 * Versuche. Ohne diese Grenze lief sie endlos alle 4 s weiter, solange etwa der Kopf außer Sicht war, und las dabei
 * jedes Mal die Lage des Topfs. Nicht auf /cart (dort hüpft die Tomate), Schluss nach einem Klick auf den Topf
 * (WCAG 2.2.2).
 * Bei „weniger Bewegung“ oder rs_bewegung_an aus (data-rs-bewegung="aus", html.ohne-bewegung) setzt das
 * Modul nur Zahl und Namen.
 */
(() => {
  'use strict';
  if (window.RSTopf) return;

  const doc = document;
  const alleToepfe = () => Array.from(doc.querySelectorAll('[data-rs-topf]'));
  const kopfToepfe = () => alleToepfe().filter((t) => !t.hasAttribute('data-rs-topf-mini'));

  const systemRuhig = () => {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  };
  const bewegt = (t) =>
    !systemRuhig() && t.getAttribute('data-rs-bewegung') !== 'aus' && !doc.documentElement.classList.contains('ohne-bewegung');

  const uhren = new WeakMap();

  // Klassen neu starten: laufende entfernen, einmal neu berechnen lassen, wieder setzen
  function spielen(toepfe, klassen, dauer) {
    toepfe.forEach((t) => {
      if (!bewegt(t)) return;
      klassen.forEach((k) => t.classList.remove(k));
      void t.offsetWidth;
      klassen.forEach((k) => t.classList.add(k));
      const alt = uhren.get(t) || {};
      klassen.forEach((k) => {
        if (alt[k]) window.clearTimeout(alt[k]);
        alt[k] = window.setTimeout(() => t.classList.remove(k), dauer + 40);
      });
      uhren.set(t, alt);
    });
  }

  let deckelUhr = null;
  function deckelAuf(an) {
    kopfToepfe().forEach((t) => {
      if (an && bewegt(t)) t.classList.add('nimmt-auf');
      else t.classList.remove('nimmt-auf');
    });
    window.clearTimeout(deckelUhr);
    // Sicherung: bleibt ein Ereignis aus, geht der Deckel nach 4 s von selbst zu
    if (an) deckelUhr = window.setTimeout(() => deckelAuf(false), 4000);
  }

  function anzahlLesen(t) {
    const a = Number(t.getAttribute('data-rs-topf-anzahl'));
    if (Number.isFinite(a) && t.hasAttribute('data-rs-topf-anzahl')) return a;
    const z = t.querySelector('[data-rs-topf-zahl]');
    const n = z ? parseInt(z.textContent, 10) : 0;
    return Number.isFinite(n) ? n : 0;
  }

  function zahlSetzen(n) {
    kopfToepfe().forEach((t) => {
      const alt = anzahlLesen(t);
      const zahl = t.querySelector('[data-rs-topf-zahl]');
      const name = t.querySelector('[data-rs-topf-name]');
      if (zahl) zahl.textContent = n > 99 ? '99+' : String(n);
      if (name) {
        // Der ganze Name in einem Text, „Warenkorb, 2 Artikel“ (rs-topf.liquid: sonst setzt Chromium
        // ein Leerzeichen vor das Komma)
        const muster = name.getAttribute('data-rs-topf-muster') || '999999 Artikel';
        const wort = name.getAttribute('data-rs-topf-wort') || '';
        const rest = muster.replace('999999', String(n));
        name.textContent = wort ? wort + ', ' + rest : rest;
      }
      t.setAttribute('data-rs-topf-anzahl', String(n));
      if (n > alt) spielen([t], ['zaehlt'], 300);
    });
  }

  const gesehen = new WeakSet();
  function hoeren(name, fn) {
    const h = (e) => {
      if (gesehen.has(e)) return;
      gesehen.add(e);
      fn(e.detail || {});
    };
    doc.addEventListener(name, h);
    window.addEventListener(name, h);
  }

  function anzahlUebernehmen(n) {
    if (!Number.isFinite(n) || n < 0) return;
    const vorher = kopfToepfe().reduce((m, t) => Math.max(m, anzahlLesen(t)), 0);
    zahlSetzen(n);
    // E-161: nach dem ersten Artikel der erste Schlag 15 s später
    if (vorher < 1 && n >= 1) koechelnIn(15000);
  }

  hoeren('rs:warenkorb:geaendert', (d) => anzahlUebernehmen(Number(d.anzahl)));

  // Ladezeit-Runde 03.10.2026 (A1): Auf der Startseite lädt im Popup-Modus kein rs-cart.js
  // (sections/rs-warenkorb-drawer.liquid). Kommt die Seite per „Zurück“ aus dem Seiten-Cache (pageshow mit
  // persisted), holt dieses Modul den Stand selbst und setzt die Zahl. Mit rs-cart.js (window.RSWarenkorb) lädt
  // das dortige pageshow den Stand und sendet rs:warenkorb:geaendert; hier bleibt es dann still.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted || window.RSWarenkorb || typeof window.fetch !== 'function') return;
    const routen = window.routes;
    const url = ((routen && routen.cart_url) || '/cart') + '.js';
    window.fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then((antwort) => (antwort && antwort.ok ? antwort.json() : null))
      .then((korb) => {
        if (korb && !window.RSWarenkorb) anzahlUebernehmen(Number(korb.item_count));
      })
      .catch(() => null);
  });

  hoeren('rs:warenkorb:hinzugefuegt', (d) => {
    if (d.landung) return;
    spielen(alleToepfe(), ['klappert'], 700);
  });

  hoeren('rs:flug:anflug', () => deckelAuf(true));

  hoeren('rs:flug:gelandet', () => {
    deckelAuf(false);
    spielen(kopfToepfe(), ['klappert'], 700);
  });

  hoeren('rs:flug:abgebrochen', () => deckelAuf(false));

  hoeren('rs:versand:frei', () => {
    // kurz nach dem Klappern, damit beide Bewegungen zu sehen sind
    window.setTimeout(() => spielen(alleToepfe(), ['dampft'], 900), systemRuhig() ? 0 : 320);
  });

  // Kopf-Fix (Feinschliff 26.09.2026, Nr. 2), steht hier, weil rs-topf.js auf jeder Seite laedt: Shrines
  // Menue-Drawer setzt aria-expanded beim Schliessen per Escape nicht zurueck. toggle feuert nach jedem
  // Oeffnen und Schliessen, gleich auf welchem Weg; die Abdunklung haengt an diesem Attribut.
  doc.querySelectorAll('header-drawer details.menu-drawer-container').forEach((d) => {
    d.addEventListener('toggle', () => {
      const s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', String(d.open));
    });
  });

  // E-158, seit E-161 mit Taktung nach Rechnung (siehe Kopf)
  const KOECHEL_MAX = 4;
  const KOECHEL_DAUER = 900;
  // Ladezeit-Runde 03.10.2026 (B7): so viele ausgelassene Schläge in Folge, dann ruht die 4-s-Wiederholung
  const KOECHEL_VERSUCHE = 5;
  let koechelZahl = 0;
  let koechelUhr = null;
  let koechelAus = false;
  let koechelRuht = false;
  let fehlversuche = 0;
  let letzteHandlung = 0;
  const imWarenkorb = () => kopfToepfe().some((t) => anzahlLesen(t) >= 1);
  // nachFehlschlag: Versuch nach einem ausgelassenen Schlag, die Zählung läuft weiter; sonst beginnt sie bei 0
  function koechelnIn(ms, nachFehlschlag) {
    window.clearTimeout(koechelUhr);
    koechelUhr = null;
    koechelRuht = false;
    if (!nachFehlschlag) fehlversuche = 0;
    if (koechelAus || koechelZahl >= KOECHEL_MAX || /\/cart\/?$/.test(window.location.pathname)) return;
    if (!kopfToepfe().some(bewegt) || !imWarenkorb()) return;
    koechelUhr = window.setTimeout(koecheln, ms);
  }
  function koecheln() {
    koechelUhr = null;
    const gesperrt = doc.hidden || Date.now() - letzteHandlung < 3000 ||
      doc.documentElement.classList.contains('rs-warenkorb-offen') ||
      !!doc.querySelector('header-drawer details[open], dialog[open], [data-rs-popup].ist-offen');
    const toepfe = gesperrt ? [] : kopfToepfe().filter((t) => {
      if (anzahlLesen(t) < 1 || !bewegt(t)) return false;
      const r = t.getBoundingClientRect();
      if (!r.width || r.bottom <= 0 || r.top >= window.innerHeight) return false;
      const a = t.closest('a, button');
      return !(a && (a.matches(':hover') || a.matches(':focus-visible')));
    });
    if (toepfe.length) {
      spielen(toepfe, ['koechelt'], KOECHEL_DAUER);
      koechelZahl += 1;
      koechelnIn(12000 + Math.random() * 6000);
    } else if (++fehlversuche < KOECHEL_VERSUCHE) {
      // ausgelassen: zählt nicht, neuer Versuch in 4 s
      koechelnIn(4000, true);
    } else {
      // B7: fünfmal in Folge ausgelassen, keine Uhr mehr bis zur nächsten Handlung oder bis der Tab sichtbar wird
      koechelRuht = true;
    }
  }
  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach((art) => {
    window.addEventListener(art, () => {
      letzteHandlung = Date.now();
      if (koechelRuht) koechelnIn(4000);
    }, { passive: true, capture: true });
  });
  doc.addEventListener('visibilitychange', () => {
    if (!doc.hidden && (koechelUhr !== null || koechelRuht)) koechelnIn(4000);
  });
  doc.addEventListener('click', (e) => {
    if (e.target && e.target.closest && e.target.closest('[data-rs-topf]')) {
      koechelAus = true;
      window.clearTimeout(koechelUhr);
      koechelUhr = null;
    }
  }, true);
  koechelnIn(8000);

  window.RSTopf = Object.freeze({ zahlSetzen });
})();
